var _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotificationAlertred(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0001 11.5777C19.0001 13.1571 19.4676 14.7012 20.3437 16.0153L20.8333 16.7497C20.9173 16.8757 20.8585 17.0471 20.7148 17.095C15.058 18.9806 8.94216 18.9806 3.28532 17.095C3.14166 17.0471 3.08286 16.8757 3.16685 16.7497L3.65647 16.0153C4.53257 14.7012 5.00007 13.1571 5.00007 11.5777V8.99991C5.00007 5.59556 7.4303 2.75881 10.6506 2.12988M9.00007 21.9999H15.0001",
    stroke: "#000536",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 5,
    r: 4,
    fill: "#F5222D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationAlertred);
export default __webpack_public_path__ + "static/media/notification-alertred.c0e363a5a9de919bab4b68b8c6d2e51d.svg";
export { ForwardRef as ReactComponent };